<style scoped>
table {
  font-family: arial, sans-serif;
  width: 100%;
}
table thead th{
  background: none !important;
  color: #3c4b64 !important;
}
td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.form-control {
  height: 100px !important;
}
.form-control:disabled, .form-control[readonly] {
  background-color: none !important;
  background: none !important;
}

.form-control:focus {
    background-color: #fff;
    border-color: none !important;
    outline: none !important;
    box-shadow: none !important;
}
.border-bottom.text-uppercase {
  border-bottom: 2px solid #3c4b64 !important;
}
.row.justify-content-between.border-bottom {
  border-bottom: 4px solid #3c4b64 !important;
}

.border-rounded-kuitansi {
  border-radius: 20px;
  border: 2px solid #3c4b64 !important;
}
</style>
<template>
    <div class="row">
      <div class="my-3 d-flex ml-auto">
        <button class="btn btn-md btn-info mr-2" @click="generateReport">Download E-Kuitansi</button>
        <button @click="$router.go(-1)" class="btn btn-md btn-dark">Kembali</button>          
      </div>
        <div class="col-lg-12 col-sm-12 col-12 px-0">
          <vue-html2pdf
              :show-layout="true"
              :float-layout="false"
              :enable-download="true" 
              :preview-modal="true"
              :paginate-elements-by-height="1400"
              :filename="'KUITANSI-' + this.items.no_kwitansi"
              :pdf-quality="2"
              :manual-pagination="false"
              :margin="1"
              pdf-format="a4"
              pdf-orientation="landscape"
              pdf-content-width=""
                @progress="onProgress($event)"
              @hasStartedGeneration="hasStartedGeneration()"
              @hasGenerated="hasGenerated($event)"
              ref="html2Pdf"
          >
              <section slot="pdf-content">
                  <div class="card card-body border-0 px-4">
                    <div class="row justify-content-between">
                      <div class="col-lg-9 col-sm-12 col-12">
                        <div class="row">
                          <div class="col-lg-5 col-sm-5 col-5 mb-2">
                            <img src="https://i.ibb.co/5xLhpFY/logo-iapi.gif" alt width="250" />
                          </div>
                        </div>
                        <p>
                          <b class="text-uppercase">Head Office : </b> 
                          Office 8 Building 12th Floor, Unit 12 I - 12 J
                          Sudirman Central Business District (SCBD) Lot 28 
                          <br>
                          Jl. Senopati Raya No. 88, Jakarta 12190, INDONESIA
                          <br>
                          Telp. (021) 293333151 72795445 - 46 (Hubungi), 08111707261 - 66 Fax : (021) 72795441, 72795449
                          <br>
                          <b class="text-uppercase">Back Office : </b>
                          Jl. Sampit II No. 15, Blok M - Kebayoran Baru, Jakarta Selatan 17130 INDONESIA
                          <br>
                          Telp. (021) 72795445 - 46 (Hubungi) Fax : (021) 72795441, 72795449
                        </p>
                      </div>

                      <div class="col-lg-3 col-sm-12 col-12 pl-xl-3 pl-sm-0 font-weight-bold d-flex align-items-end mb-3">                        
                        <span style="font-size:17px"> No. {{this.items.no_kwitansi ? this.items.no_kwitansi : '-'}}</span>                      
                      </div>
                    </div>
                    <div class="border-rounded-kuitansi p-4">
                      <div class="row">
                        <h3 class="text-uppercase mx-auto font-weight-bold">KUITANSI</h3>
                      </div>
                      <div class="row my-4">
                          <div class="col-sm-3 mt-3 font-italic">Sudah diterima dari</div>
                          <div class="col-sm-9 mt-3 font-weight-bold text-uppercase">: {{ items.atas_nama ? items.atas_nama : '-' }}</div>
                          <div class="col-sm-3 mt-3 font-italic">Jumlah Uang</div>
                          <div class="col-sm-9 mt-3">: Rp. {{formatPrice(dataPayment.nominal) ? formatPrice(dataPayment.nominal) : '0'}}</div>
                          <!-- <div class="col-sm-3 mt-3 font-italic">Terbilang</div>
                          <div class="col-sm-9 mt-3">: TIGA RATUS RIBU RUPIAH</div> -->
                          <div class="col-sm-3 mt-3 font-italic">Untuk Pembayaran</div>
                          <div class="col-sm-9 mt-3">: {{dataPayment.namaItem ? dataPayment.namaItem : '-'}}</div>
                      </div>
                      <div class="row justify-content-between align-items-center mt-3">
                        <div class="col-md-8">
                          <p class="h5">
                            <i>Jumlah : </i>
                            <b class="ml-3 text-uppercase">Rp. {{formatPrice(this.items.nominal) ? formatPrice(this.items.nominal) : '0'}}</b>
                          </p>
                        </div>   
                        <div class="col-md-4">
                          <label for="">Jakarta, {{ tanggal_pembayaran }}</label>
                            <div class="form-group">
                              <input type="text" class="form-control" readonly>
                            </div>
                            <h5 class="mx-auto">Kadiv Keuangan & Umum</h5>
                        </div>   
                      </div>
                    </div>
                  </div>
              </section>
          </vue-html2pdf>
      </div>
    </div>
</template>
<script>
import moment from 'moment'
import PaymentService from '@/services/finance/payment.service'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  data() {
    return {
      tanggal_pembayaran: "",
      items: {},
      dataPayment: {},
      hasStartedGeneration: false
    }
  },

  mounted() {
    this.getData()
    localStorage.getItem('filterPembayaran')
  },

  methods: {    
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    getData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      PaymentService.getInvoice(this.$route.params.id_invoice)
        .then(response => {
          loader.hide();
          vm.items = response.data.singleData;
          vm.dataPayment = response.data.singleData.item_payment[0]
          vm.tanggal_pembayaran = response.data.singleData.tanggal_pembayaran ? moment(response.data.singleData.tanggal_pembayaran).locale('Id').format('DD MMMM YYYY') : "-"
        })
        .catch(error => {
          loader.hide();
        });
    },
  }
}
</script>